'use strict';

function MarkupUtilities() {
  this.generateLetterizedMarkup = function (string) {
    // TODO: should be using specific classes, pass them in or make generic (perhaps component?)
    var wordClass = 'protect-affiliate-header-title__spaced-lines';
    var letterClass = 'protect-affiliate-header-title__spaced-line-text';

    var markup = '<div class="' + wordClass + '">';
    for (var i = 0; i < string.length; i++) {
      if (string.charAt(i) === ' ') {
        markup += '</div><div class="' + wordClass + '">';
      } else {
        markup += '<span class="' + letterClass + '">';
        markup += string.charAt(i);
        markup += '</span>';
      }
    }
    markup += '</div>';
    return markup;
  };

  this.init = function () {};

  this.initAllReady = function () {};
}